import React, { useState, useEffect } from "react";

import axios from "axios";
import { uri } from "../../../help/Api";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
//import {useStylesHed} from '../../../St/comps/UseStyle';
import { useInvCa } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import { QRCodeCanvas } from "qrcode.react";

function FooterCash(props) {
    const { found, sta, inv, locInv, onUnmountComplete } = props;
    const clas = useInvCa();

    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);
    const sty = {
        cntr: { textAlign: "center" },
        lft: { textAlign: "left", padingLeft: 5 },
        rit: { textAlign: "right", padingRight: 5 },
        dirR: { direction: "rtl", color: "black" },
        dirL: { direction: "ltr" },
    };

    return (
        <Grid item container style={sty.dirR}>
            <Grid item container xs={12} style={sty.cntr} spacing={1}>
                {inv?.notes?.toString()?.startsWith('Receipt voucher') && (
                    <Grid item xs={12}>
                        {inv?.notes}
                    </Grid>
                )}             
                <Grid item xs={12}>
                    {(locInv?.Step_inv2 && inv?.ZatcaQR) ?
                        (
                            <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                                {
                                    <QRCodeCanvas value={inv?.ZatcaQR} />
                                }

                            </ButtonBase>
                        ) :
                        (
                            <ButtonBase
                                style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0}}
                            >
                                {
                                    <img
                                        src={`data:image/jpeg;base64,${inv.qr_image}`}
                                        style={{ height: "45mm", width: "45mm" }}
                                    />
                                }
                            </ButtonBase>
                        )}

                </Grid>
                <Grid item xs={12}>
                    {sta?.tot?.sales_emp_name}
                </Grid>
                {(found.BillNotes != "...." && found.BillNotes != null && found.BillNotes != "")
                    && (
                        <Grid
                            item
                            container
                            xs={12}
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                fontWeight: "bold",
                                direction: "rtl",
                                fontFamily: "Amiri-Regular",
                                textAlign: "right"
                            }}
                        >
                            {found.BillNotes}
                        </Grid>
                    )}
            </Grid>
        </Grid>
        // </span>
    );
}
export default FooterCash;





